<template>
  <li class="item" :class="{'v1' : conteudoCard}" :style="itemHeight">
    <a @click="$router.push(url)" href="javascript:void(0)">
      <div class="home-carousel" :style="minHeight">
        <img :src="requireImage()" class="img-carousel-disciplina-categoria img-fluid" v-if="categoriaCarousel || disciplinaCarousel"/>
        <img :src="requireImage()" class="img-caroulsel img-fluid" v-else-if="imagem" />
        <div class="nome-curso" :style="continuarAssistindo ? 'bottom: 46px' : 'bottom: 15px'" v-if="!categoriaCarousel && !disciplinaCarousel">
          <p>{{ titulo }}</p>
        </div>
        <div class="progresso" v-if="progresso || progresso === 0">
          <div class="progress">
            <div class="progress-bar" role="progressbar" :style="progressWidth" :aria-valuenow="progresso" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <div class="d-flex justify-content-between" v-if="dataExpiracao && continuarAssistindo && cursoComDataExpiracao">
            <p v-if="isCursoExpirado">Expirado em <strong>{{ formatDate(dataExpiracao) }}</strong></p>
            <p v-else>Expira em <strong>{{ formatDate(dataExpiracao) }}</strong></p>
            <p><strong>{{ progresso }}%</strong> concluído</p>
          </div>
          <div v-else>
            <p style="position: absolute"><strong>{{ progresso }}%</strong> concluído</p>
          </div>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
import $ from 'jquery'
import ImageUtils from '@/core/utils/image-utils'
import DateUtils from '@/core/utils/date-utils'

export default {
  name: 'CarouselItem',
  props: {
    titulo: String,
    tituloUrl: String,
    url: {
      type: String,
      default: '#'
    },
    textoUrl: String,
    imagem: String,
    conteudoCard: String,
    cardHover: {
      type: Boolean,
      default: true
    },
    targetModal: String,
    progresso: Number,
    video: Object,
    dataExpiracao: String,
    continuarAssistindo: Boolean,
    categoriaCarousel: Boolean,
    disciplinaCarousel: Boolean
  },
  mounted () {
    $('.card-hover').css('opacity', '0')

    $('.item').hover(function () {
      $(this).children('.card-hover').css('opacity', '1')
      $(this).children('.card-conteudo').css('opacity', '0')
    }, function () {
      $(this).children('.card-hover').css('opacity', '0')
      $(this).children('.card-conteudo').css('opacity', '1')
    })
  },
  methods: {
    requireImage () {
      return ImageUtils.obterUrlCompletaImagem(this.imagem)
    },
    hasSlotData () {
      return this.$slots.default
    },
    openVideoModal (targetModal, video) {
      this.$emit('videoAtivoChange', video)
      this.$bvModal.show(targetModal)
    },
    formatDate: function (date) {
      let pattern = 'DD/MM/YYYY'
      return DateUtils.formatDate(date, pattern)
    }
  },
  computed: {
    progressWidth: function () {
      if (this.progresso) {
        return `width: ${this.progresso}%`
      }
      return ''
    },
    cursoComDataExpiracao: function () {
      return this.$empresaUtils.temAcesso(this.$tipoAcesso.CURSO_DATA_EXPIRACAO.nome, this.$configEmpresa.rotasRestritasAcesso)
    },
    itemHeight: function () {
      return this.categoriaCarousel || this.disciplinaCarousel ? 'height:127px' : 'height:280px'
    },
    minHeight: function () {
      return this.categoriaCarousel || this.disciplinaCarousel ? 'min-height:127px' : 'min-height:280px'
    },
    isCursoExpirado: function () {
      return this.dataExpiracao < DateUtils.currentDateTime()
    }
  }
}
</script>

<style scoped>

</style>
